import React from 'react';
import styles from './footer-xsci.module.css'
import {useTranslation} from "react-i18next";

const CompanySection = () => {
    const {t, i18n} = useTranslation();


    return (

        <div className={`col-md-3 col-12 my-sm-0 mt-5 ${styles.section_container}`}>
            <ul className="list-unstyled" >
                <li className={`mt-md-3 mt-4 ${styles.section_title}`}>{String(t('footer.company'))}</li>
                <li className={styles.section_li}><a href="/public" className={styles.section_link}>
                    {String(t('footer.home'))}
                </a></li>
                <li className={styles.section_li}> <a href="/about" className={styles.section_link}>
                    {String(t('footer.about'))}
                </a></li>
                <li className={styles.section_li}>  <a href="/privacy" className={styles.section_link}>
                    {String(t('footer.privacy'))}
                </a></li>
            </ul>
        </div>

    );
};

export default CompanySection;